import Cookies from 'js-cookie';
import Config from './config';
import HttpUtil from './httpUtil';

// Verifica acessos a ferramenta e salva no painel de acessos do principal
export class LogsServiceAPI {

	salvarLog(cookie, id_ferramenta, id_acao) {

		const token = this.getToken(cookie);
		
		if (token) {

			let dataToken = new FormData();
			
			dataToken.append('id_ferramenta', id_ferramenta);
			dataToken.append('id_usuario', token["id"]);
			dataToken.append('ip_usuario', token["ip_usuario"]);
			dataToken.append('bl_interno', token["bl_interno"]);
			dataToken.append('id_acao_usuario', id_acao);
			dataToken.append('data', new Date(new Date().getTime()).toISOString());

			// console.log(dataToken);

			HttpUtil.eco_POST(
				`${Config.urls.API_URL_BASE}Acesso/CriarLogPainelAcessos`,dataToken ,response => {

					if(!response.data)
					{
						console.log("Erro Acesso/CriarLogPainelAcessos");
					}
				},
				() => {
					
					console.log("Ex Acesso/CriarLogPainelAcessos");
				},
			);
		}
	}

	getToken(cookie) {
		// Pega o cookie do site Econet
		let token = "";
		cookie = Cookies.get('bG9naW4');
		
		const cookieEconet = cookie;

		if (cookieEconet !== undefined && cookieEconet !== "") {
			const strToken = window.atob(cookieEconet);
			if (typeof strToken == "string") {
				token = JSON.parse(strToken);
			}
		}
		return token;
	}
}
